import React from 'react';
import { useNavigate } from 'react-router-dom';
import JobSeekerPackagePurchase from '../components/JobSeekerPackagePurchase';
import EmployerPackagePurchase from '../components/EmployerPackagePurchase';
import Footer from '../components/Footer';
import ContentWithAds from '../components/ContentWithAds';
import FranchisePackagePurchase from '../components/FranchisePackagePurchase';

const PackagesPage = ({ user, userData, refreshUserData }) => {
  const navigate = useNavigate();

  // Determine which component to show based on user type
  const isEmployer = userData?.userType === 'employer';
  const isJobSeeker = userData?.userType === 'jobseeker';
  const isFranchise = userData?.userType === 'franchise';

  // After a successful purchase, refresh userData first then navigate to the dashboard
  const handlePurchaseSuccess = async () => {
    // Refresh userData so the destination dashboard loads with the new subscription
    if (refreshUserData && user?.uid) {
      await refreshUserData(user.uid);
    }
    if (isEmployer) {
      navigate('/dashboard/employer', { replace: true });
    } else if (isJobSeeker) {
      navigate('/dashboard/jobseeker', { replace: true });
    } else if (isFranchise) {
      navigate('/franchise/dashboard', { replace: true });
    } else {
      navigate('/dashboard', { replace: true });
    }
  };

  if (!userData?.userType) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50">
        <div className="text-center p-8">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading packages...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 pb-24 lg:pb-0">
        <ContentWithAds>
          {isEmployer && (
            <EmployerPackagePurchase
              user={user}
              userData={userData}
              showCurrentPackage={true}
              onPurchaseSuccess={handlePurchaseSuccess}
            />
          )}

          {isJobSeeker && (
            <JobSeekerPackagePurchase
              user={user}
              userData={userData}
              onPurchaseSuccess={handlePurchaseSuccess}
            />
          )}

          {isFranchise && (
            <FranchisePackagePurchase
              user={user}
              userData={userData}
              onPurchaseSuccess={handlePurchaseSuccess}
            />
          )}

          {!isEmployer && !isJobSeeker && !isFranchise && (
            <div className="max-w-4xl mx-auto px-4 py-16 text-center">
              <div className="bg-white rounded-2xl shadow-xl p-12 border border-gray-200">
                <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <svg className="w-10 h-10 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Invalid User Type</h2>
                <p className="text-gray-600 mb-6">
                  Your account type is not recognized. Please contact support.
                </p>
                <p className="text-sm text-gray-500">
                  User Type: <span className="font-mono bg-gray-100 px-2 py-1 rounded">{userData?.userType || 'undefined'}</span>
                </p>
              </div>
            </div>
          )}
        </ContentWithAds>
      </div>

      {/* Footer - Only show on desktop for this page as requested */}
      <div className="hidden md:block">
        <Footer />
      </div>
    </>
  );
};

export default PackagesPage;
